import React, { useEffect, useState } from "react";
import { withOrientationChange } from "react-device-detect";
import Lottie from "react-lottie-player";
import { useTranslation } from "react-i18next";

import styled from "styled-components";
import { device } from "../device.js";

import LandscapeErrorPage from "../ErrorPage/LandscapeErrorPage";

const Wrapper = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: #f9dcb6;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledLottie = styled(Lottie)`
  width: 70%;
  height: auto;
  @media ${device.mobileXS} {
    width: 70%;
  }
  @media ${device.mobileS} {
    width: 75%;
  }
  @media ${device.mobileM} {
    width: 80%;
  }
  @media ${device.mobileL} {
    width: 70%;
  }
`;
const IosChromeErrorPage = (props) => {
  const { isLandscape } = props;
  const { i18n } = useTranslation();

  const [lottie, setLottie] = useState("");

  useEffect(() => {
    const lottieLoader = async () => {
      if (i18n.language === "zh") {
        const lottieData = await import(
          "../../assets/error_lottie/error_unsupported_chrome/en/lennie_unsupport_brownser_safari.json"
        );
        setLottie(lottieData.default);
      } else {
        const lottieData = await import(
          "../../assets/error_lottie/error_unsupported_chrome/zh/lennie_unsupport_brownser_safari.json"
        );
        setLottie(lottieData.default);
      }
    };
    lottieLoader();
  }, [i18n.language]);

  if (isLandscape) {
    return <LandscapeErrorPage />;
  }
  return (
    <Wrapper>
      <StyledLottie
        loop
        play
        animationData={lottie}
        rendererSettings={{ preserveAspectRatio: "xMidYMid slice" }}
      />
    </Wrapper>
  );
};

export default withOrientationChange(IosChromeErrorPage);
